import "./bootstrap";
import "../css/app.css";

import { createApp, DefineComponent, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

import Vapor from "laravel-vapor";
import { route, ZiggyVue } from "ziggy-js";
import moment from 'moment';

Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL);

import { register } from 'designertool'
register()
window.Vapor = Vapor;

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText || "Designer Tool";

moment.defaultFormat = 'MMM DD, YYYY';

import.meta.glob(["../images/**", "../fonts/**"]);

createInertiaApp({
    title: (title) => `${title} | ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob<DefineComponent>("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)

             
            .use(ZiggyVue)
            .mixin({
                methods: {
                    asset: window.Vapor.asset,
                },
            });

        app.config.globalProperties.$route = route;
        app.mount(el);
    },
    progress: {
        color: "#E54052",
    },
});
